"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "initializeSegment", {
  enumerable: true,
  get: function get() {
    return _Segment.initializeSegment;
  }
});

var _Segment = require("./lib/Segment");